//import pweewee from '../assets/images/pweeweeBFrostTournament.png'
// import squirt from '../assets/images/squirtBTourny.png'
// import mite from '../assets/images/miteJam3.png'
import bantam from '../assets/images/bantam26update.png'



  

const Bracket = () => {
  return (
    <div className='bracket-container'>
      <h2 style={{ marginTop: '30px', fontWeight: 'bold' }}>Brackets</h2>
      {/* <h3>No Upcomming Tournaments</h3> */}

    {/* <img className='marginBottom' src={squirt} alt="Tournament Squirt" />  */}
    <img className='marginBottom' src={bantam} alt="Tournament Bantam" /> 
         
    </div>
  );
};

export default Bracket;
